import { fromLonLat } from "ol/proj";
import { Layers, BasemapLayer, GeoserverWMSLayer, ArcgisWMSLayer } from "./Map/Layers";
import { Controls, ZoomControl } from "./Map/Controls";
import { Interactions } from "./Map/Interactions";

import Map from "./Map";

import { useState, useEffect } from 'react';
import Config from '../config.json';

export default function MapDataPreview({ center, zoom, basemap }) {
  //https://ungegn-ased.big.go.id/geoserver/ungegn/wms?service=WMS&version=1.1.0&request=GetMap&layers=ungegn:HYDRO_POLYGON&bbox=103.63798609300005,1.2802021700000523,104.05063686000005,1.4693693780000672&width=768&height=352&srs=EPSG:4326&styles=&format=image/png
  const [listData, setListData] = useState();
  const [listService, setListService] = useState();

  const url_contribution = Config.api_domain + "/contribution/";
  const url_webservice = Config.api_domain + "/webservices/";


  useEffect(() => {

    try {
      // Fetch data from REST API
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      };

      fetch(url_contribution, requestOptions)
        .then(res => res.json())
        .then(data => {
          //console.log(data)
          setListData(data.data)
        })
        .catch((error) => {
          console.error('Error:', error);
        });;

      fetch(url_webservice, requestOptions)
        .then(res => res.json())
        .then(data => {
          console.log(data)
          setListService(data.data)
        })
        .catch((error) => {
          console.error('Error:', error);
        });;

    } catch (error) {
      alert(`Error ${error}`)
    }
  }, []);

  function view_data_contribution() {
    if (typeof (listData) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listData !== null) {

        if (listData.length > 0) {

          return listData.map((row, index) => {
            //console.log(row)
            return <GeoserverWMSLayer key={index} filename={row.filename} />
          })
        } else {
          return null
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  function view_data_services() {
    if (typeof (listService) !== 'undefined') {
      //var items=props.presensiDataLast.data;
      if (listService !== null) {

        if (listService.length > 0) {

          return listService.map((row, index) => {
            //console.log(row)
            console.log(row.url_link)
            return <ArcgisWMSLayer keys={index} url={row.url_link} />
          })
        } else {
          return null
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  return (
    <Map center={fromLonLat(center)} zoom={zoom} >
      <Layers>
        <BasemapLayer basemap={basemap} zIndex={0} />
        {
          view_data_contribution()
        }
        {
          view_data_services()
        }

        {


          /*
           <ArcgisWMSLayer url={'https://geoservices.big.go.id/rbi/rest/services/TOPONIMI/TOPONIM_PT_5K/MapServer'} />
                  <GeoserverWMSLayer filename={'BANGUNAN_AR_25K.shp'} />
        <GeoserverWMSLayer filename={'DANAU_AR_50K.shp'} />
        <GeoserverWMSLayer filename={'TRANSPORTATION_LINE.shp'} />

        <ArcgisWMSLayer url={'https://geoservices.big.go.id/rbi/rest/services/TOPONIMI/TOPONIM_PT_5K/MapServer'} />
          */}


      </Layers>
      <Controls>
        <ZoomControl />
      </Controls>
      <Interactions>
      </Interactions>

    </Map>
  )
}